var _linearGradient, _path, _path2, _path3, _linearGradient2, _rect, _radialGradient, _path4, _linearGradient3, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Glassrepairreplacement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Pt0cmnyf7uqY1_zEvPdqSa",
    x1: 6.91,
    x2: 42.421,
    y1: 1.403,
    y2: 48.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbc1c4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Pt0cmnyf7uqY1_zEvPdqSa)",
    d: "M40,6v36c0,0.21-0.03,0.41-0.09,0.6c-0.05,0.17-0.13,0.32-0.22,0.47 c-0.09,0.14-0.2,0.27-0.32,0.37C39.01,43.8,38.53,44,38,44H10c-0.54,0-1.02-0.2-1.38-0.55c-0.12-0.11-0.22-0.24-0.31-0.38 c-0.09-0.15-0.17-0.3-0.22-0.47C8.03,42.41,8,42.21,8,42V6c0-0.2,0.03-0.38,0.08-0.56c0.04-0.16,0.11-0.32,0.2-0.46 c0.08-0.15,0.18-0.28,0.3-0.4C8.94,4.22,9.44,4,10,4h28c0.54,0,1.02,0.21,1.38,0.55c0.12,0.12,0.22,0.24,0.31,0.38 s0.17,0.29,0.22,0.46V5.4C39.97,5.59,40,5.79,40,6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.56,7.27L8.58,4.58c-0.12,0.12-0.22,0.25-0.3,0.4c-0.09,0.14-0.16,0.3-0.2,0.46L12,8.1V40l-3.91,2.6 c0.05,0.17,0.13,0.32,0.22,0.47c0.09,0.14,0.19,0.27,0.31,0.38l3.93-2.62L13,40.54V7.57L12.56,7.27z M39.91,5.4V5.39 c-0.05-0.17-0.13-0.32-0.22-0.46s-0.19-0.26-0.31-0.38l-3.93,2.62L35,7.46v33.08l0.45,0.29l3.92,2.61 c0.12-0.1,0.23-0.23,0.32-0.37c0.09-0.15,0.17-0.3,0.22-0.47L36,40V8L39.91,5.4z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.28,7.69l-4-2.71c-0.09,0.14-0.16,0.3-0.2,0.46L12,8.1V40l-3.91,2.6c0.05,0.17,0.13,0.32,0.22,0.47l3.97-2.65 l0.22-0.15V7.83L12.28,7.69z M39.91,5.4V5.39c-0.05-0.17-0.13-0.32-0.22-0.46l-3.97,2.65L35.5,7.73v32.54l0.22,0.15l3.97,2.65 c0.09-0.15,0.17-0.3,0.22-0.47L36,40V8L39.91,5.4z",
    opacity: 0.07
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Pt0cmnyf7uqY1_zEvPdqSb",
    x1: 13.963,
    x2: 31.719,
    y1: -3.576,
    y2: 45.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0176d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16538c"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 32,
    x: 10,
    y: 8,
    fill: "url(#Pt0cmnyf7uqY1_zEvPdqSb)"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Pt0cmnyf7uqY1_zEvPdqSc",
    cx: 24,
    cy: 24,
    r: 43.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f0f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#d9dcdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2c8cc"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Pt0cmnyf7uqY1_zEvPdqSc)",
    d: "M12,40l-8.223,5.482C3.445,45.703,3,45.465,3,45.066V2.943c0-0.401,0.449-0.639,0.781-0.414 L12,8.1V40z M36,8v32l8.223,5.482C44.555,45.703,45,45.465,45,45.066V2.934c0-0.399-0.445-0.638-0.777-0.416L36,8z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Pt0cmnyf7uqY1_zEvPdqSd",
    x1: 6.697,
    x2: 43.871,
    y1: -3.684,
    y2: 55.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a85d9"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Pt0cmnyf7uqY1_zEvPdqSd)",
    d: "M5,20h5v19l-5,3.3V20z M5,5.8V18h5V9L5,5.8z M43,5.7L38,9v9h5V5.7z M38,20v19l5,3.2V20H38z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Glassrepairreplacement);
export default __webpack_public_path__ + "static/media/icons8-glassrepairreplacement.9abd6ce5bb349b869498d6647701fc1b.svg";
export { ForwardRef as ReactComponent };